var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.994,
    height: 20.095,
    viewBox: "0 0 20.994 20.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.b{clip-path:url(#a);}.c{stroke:#66615b;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20.994,
    height: 20.094
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-167.257 816.072) rotate(-42)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 3.392,
    cy: 3.439,
    rx: 3.392,
    ry: 3.439,
    transform: "matrix(0, -1, 1, 0, 661.872, -476.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M737.416-452.345H725.175",
    transform: "translate(-56.421 -27.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M781.1-449.486v-2.833",
    transform: "translate(-106.937 -27.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M799.03-450v-2.345",
    transform: "translate(-122.246 -27.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M816.957-449.508v-2.833",
    transform: "translate(-137.481 -27.136)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.c2ef6450be4be45d74635adc13e99b7f.svg";
export { ForwardRef as ReactComponent };